<template>
  <div :id="id"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
// import * as am4plugins_regression from '@amcharts/amcharts4/plugins/regression';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
/* Chart code */
am4core.options.queue = true;
// Themes begin
am4core.useTheme(am4themes_animated);
am4core.addLicense('CH315878972');
// Themes end
export default {
  props: {
    id: {
      type: String,
      default: 'chartdiv',
    },
    colors: {
      type: Array,
      default: () => ['#f799d1', '#e04074'],
    },
    data: {
      type: Array,
      default: () => [
        {
          date: '2008-01-01',
          value: 1,
        },
        {
          date: '2009-01-02',
          value: 0.9,
        },
      ],
    },
    yAxis: {
      type: Object,
      default: () => ({
        label: 'Value',
      }),
    },
    xAxis: {
      type: Object,
      default: () => ({
        label: 'Year',
      }),
    },
  },
  mounted() {
    const self = this;
    const chartContainer = document.getElementById(this.id);
    chartContainer.style.width = '100%';
    chartContainer.style.height = '40em';
    // Create chart instance
    const chart = am4core.create(this.id, am4charts.XYChart);

    // Enable chart cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;
    chart.paddingLeft = 25;

    // Enable scrollbar
    // chart.scrollbarX = new am4core.Scrollbar();
    // this.data.forEach((row) => {
    //   const value = row.Value.split('%');
    //   row.Value = parseFloat(value[0]);
    //   // row.Year = `${row.Year}-01-01`;
    // });
    chart.data = this.data;
    const categoryXAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryXAxis.dataFields.category = self.xAxis.label;
    categoryXAxis.numberFormatter.numberFormat = '####';
    categoryXAxis.fontSize = 12;
    categoryXAxis.renderer.minGridDistance = 20;
    categoryXAxis.title.text = this.xAxis.label;

    const valueYAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueYAxis.title.text = 'modal percentage breakdown of journeys made';
    valueYAxis.fontSize = 12;
    valueYAxis.numberFormatter.numberFormat = '#.##';

    // const bottomLabel = chart.chartContainer.createChild(am4core.Label);
    // bottomLabel.text = this.xAxis.label;
    // bottomLabel.x = am4core.percent(50);
    // bottomLabel.opacity = 0.5;
    // const leftLabel = chart.createChild(am4core.Label);
    // leftLabel.text = 'modal percentage breakdown of journeys made';
    // leftLabel.opacity = 0.5;
    // leftLabel.fontSize = 15;
    // leftLabel.rotation = -90;
    // leftLabel.isMeasured = false;
    // leftLabel.y = am4core.percent(60);
    // leftLabel.x = -18;

    // Create series
    function createSeries(field, name, color) {
      const series = chart.series.push(new am4charts.LineSeries());
      series.tooltipText = '{name}\n[bold font-size: 17px]{categoryX}: {valueY}%[/]';
      series.dataFields.valueY = field;
      series.dataFields.categoryX = self.xAxis.label;
      series.strokeWidth = 4;
      series.name = name;
      series.fill = am4core.color(color);
      series.stroke = am4core.color(color);

      const bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.strokeWidth = 1;
      bullet.circle.radius = 6;
      bullet.stroke = am4core.color('#fff');
      bullet.setStateOnChildren = true;
      bullet.propertyFields.fillOpacity = 'opacity';
      bullet.propertyFields.strokeOpacity = 'opacity';

      const bulletHoverState = bullet.states.create('hover');
      bulletHoverState.properties.scale = 1.7;
    }

    createSeries('Modal share of all journeys', 'Modal share of all journeys', this.colors[0]);
    createSeries('Travel to work', 'Travel to work', this.colors[1]);
    createSeries('Journeys under 5 miles by cycling', 'Journeys under 5 miles by cycling', this.colors[2]);
    // const trend = chart.series.push(new am4charts.LineSeries());
    // trend.dataFields.valueY = this.yAxis.label;
    // trend.dataFields.valueX = this.xAxis.label;
    // trend.strokeWidth = 4;
    // trend.strokeDasharray = '3,3';
    // trend.plugins.push(new am4plugins_regression.Regression());

    // const trendBullet = trend.bullets.push(new am4charts.CircleBullet());
    // trendBullet.tooltipText = '{valueX}\n[bold font-size: 17px]value: {valueY}[/]';
    // trendBullet.strokeWidth = 2;
    // trendBullet.circle.radius = 6;
    // trendBullet.stroke = am4core.color('#fff');
    // trendBullet.circle.fill = trend.stroke;

    // const hoverState = trendBullet.states.create('hover');
    // hoverState.properties.scale = 1.7;
  },
};
</script>

<style></style>
